<template>
    <div id="halamandepan" class="" >
          <div style="height:100%;width:100%;position:absolute;z-index:100;" id="particlesjsmain" ></div>
          <div v-if="ready" class="text-center animate__animated animate__flipInX animate__delay-2s" style="position:absolute;z-index:100020;width:100%;bottom:50px;">
                <button type="button" @click="bukaundangan" class="btn btn-sm btn-style8 rounded-lg"><span class="typcn typcn-mail text-xl"></span> Buka Undangan</button>
          </div>
        <div class="row justify-content-center animate__animated animate__backInUp  text-white" v-if="ready">
          <div class="col-12" style="height:100vh;width:100%;background:#100001;position:relative;">
            <img :src="$store.state.data.undangan.gambar3" 
            style="height:100%;width:100%;position:absolute;right:0;top:0;z-index:10;filter: brightness(50%);" alt="">
              <div style="height:100%;position:absolute;width:100%;z-index:11;margin-left:-20px;" class="d-flex justify-content-center align-items-center shadow-lg rounded-lg text-center">
                  <div style="width:100%" class="">
                      <img src="@/static/couple2.png" v-viewer style="width:40vh;height:40vh;display:block;margin:auto;"
                       class="rounded-circle shadow" alt="">
                    <!-- <img src="@/static/flowerring1.jpg" style="width:20vw;height:20vw;position:absolute;"
                       class="rounded-circle shadow" alt=""> -->
                      <div class="row justify-content-center">
                        <div class="col-6">
                            <p class="text-3xl sm:text-5xl  text-center wow"
                             style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                              {{undangan.nama_singkat1}} & {{undangan.nama_singkat2}}
                            </p>
                            <p class="text-xl sm:text-2xl text-center" style="font-family: 'Glory', sans-serif;">
                                Kepada Yth. Bapak/Ibu/Saudara/i
                            </p>
                            <p class="text-center font-italic text-sm" style="font-family: 'Glory', sans-serif;">
                                *Mohon Maaf bila ada kesalahan penulisan nama dan gelar
                            </p>
                           <br>
                           <br>
                           <br>
                           <br>
                         
                        </div>
                      </div>
                  </div>
              </div>
            <!-- <img src="@/static/undangan/draw3.png" style="height:35%;width:75%;position:absolute;bottom:0;left:0;"  alt=""> -->
          </div>
        </div>
        <div v-else>
          <div style="height:100vh;" class="d-flex justify-content-center align-items-center ">
              <div style="width:100%" class="text-center">
                  <p class="animated bounce infinite text-2xl font-semibold text-center p-5 text-black">
                    <span class="typcn typcn-heart text-red-500 text-5xl "></span> <br>
                  </p>
              </div>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://undangan.officialapp.website";
export default{
    data(){
        return{
          undangan:[],
          ready:false
        }
    },
    created() {
    },
    mounted() {
      window.particlesJS("particlesjsmain", this.$store.state.particle)
      setTimeout(() => {
        this.getUndangan();
      }, 1000);
    },
    methods: {
       getUndangan(){
        let id='1'        
        let that=this;
        setTimeout(() => {
            that.ready=true;
        },2000);
        sdb.collection("app_undangan_nikah",false,urlnya).doc().select(`select *,tb1.id as id from app_undangan_nikah tb1 left join app_undangan_nikah_mempelai tb2 on tb2.id=tb1.mempelai where tb1.id='${id}'`).then(res => {
                this.undangan=res[0];
                that.$store.state.data.undangan=res[0]
                 sdb.collection("app_undangan_nikah_galery",false,urlnya).doc().select(`select * from app_undangan_nikah_galery where undangan='${id}'`).then(res => {
                    that.$store.state.data.galery=res
                     sdb.collection("app_undangan_nikah_acara",false,urlnya).doc().select(`select * from app_undangan_nikah_acara where undangan='${id}'`).then(res => {
                        that.$store.state.data.acara=res
                        that.$forceUpdate();
                    });
                });
            });
        },
      // getUndangan(){
      //   let id='1'        
      //   sdb.collection("app_undangan_nikah",false,urlnya).doc().select(`select *,tb1.id as id from app_undangan_nikah tb1 left join app_undangan_nikah_mempelai tb2 on tb2.id=tb1.mempelai where tb1.id='${id}'`).then(res => {
      //       this.undangan=res[0];
      //       console.log(this.undangan)
      //       this.$forceUpdate();
      //   });
        
      // },
      bukaundangan(){
        this.$store.state.data.interact=1;
        document.querySelector('#halamandepan').classList.remove('animate__backInUp')
        document.querySelector('#halamandepan').classList.add('animate__slideOutLeft')
        setTimeout(() => {
          this.$router.push(`/undangan?id=${this.undangan.id}`)
        }, 800);
      }
        
    },
}
</script>
<style>
::-webkit-scrollbar {
  width: 5px;
  height:5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px transparent; 
  border-radius: 5px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  cursor: grab;
  background: black; 
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>